import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { publicApi } from "@/lib/api";

const WHATSAPP_NUMBER = "919933237121";
const DEFAULT_MESSAGE = "Hi Andaman Avalon! I'm interested in your tour packages. Can you help me plan my trip?";

export const buildWhatsAppLink = (message = DEFAULT_MESSAGE) => {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
};

// Fire-and-forget click tracker. Safe to call from any onClick handler.
export const trackWhatsAppClick = (context = "unknown", package_name = "") => {
  try {
    publicApi.post("/inquiries/whatsapp-click", {
      page_url: window.location.pathname,
      package_name,
      context,
    }).catch(() => {});
  } catch (e) {
    // best-effort, do not block navigation
  }
};

const FloatingWhatsApp = () => {
  return (
    <motion.a
      href={buildWhatsAppLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      onClick={() => trackWhatsAppClick("floating_button")}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-lg group flex items-center"
      style={{ boxShadow: "0 4px 20px rgba(37, 211, 102, 0.4)" }}
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={28} className="fill-white" />
      <span className="ml-2 max-w-0 overflow-hidden group-hover:max-w-xs group-hover:ml-2 whitespace-nowrap font-medium transition-[max-width] duration-300">
        Chat on WhatsApp
      </span>
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25 -z-10"></span>
    </motion.a>
  );
};

export default FloatingWhatsApp;
